import { SyncPortError } from '../../shared/errors.js';

export type SignalingFailure = 'unreachable' | 'room-not-found' | 'room-full' | 'inbox-not-found' | 'inbox-unauthorized' | 'other';

export class SignalingConnectionError extends SyncPortError {
  constructor(
    readonly failure: SignalingFailure,
    message: string,
  ) {
    super(message);
  }
}

export class PeerConnectionError extends SyncPortError {}

/** ICE gave up: no candidate pair worked, typically a network or TURN problem. */
export class PeerConnectionFailedError extends PeerConnectionError {}

export class TransferRejectedError extends SyncPortError {}

export class TransferIncompleteError extends SyncPortError {
  constructor(
    readonly expectedBytes: number,
    readonly receivedBytes: number,
  ) {
    super(`Transfer ended after ${receivedBytes} of ${expectedBytes} bytes`);
  }
}

export class IceConfigError extends SyncPortError {}

/** The inbox owner looked at the request and said no. */
export class InboxDeclinedError extends SyncPortError {}
